export const barcodify = (input, minimum) => {

    if (!input || !minimum) {
        return null;
    }

    let value = input;
    if (typeof (input) === 'string') {
        value = Number(input);
    }

    return value.toLocaleString('en-US', { minimumIntegerDigits: minimum, useGrouping: false });
}
